<template>
  <router-link :to="{ name: 'user.profile' }">
  <picture class="pl-3 pr-3" >
    <img :src="avatarUser"  class="rounded-circle img-fluid" style="width: 2.5em;height: 2.5em" alt="profile img"> <span class="profile-alias">{{user.apelido}}</span>
  </picture>
  </router-link>
</template>

<script>
   import { mapState} from 'vuex'
   import {imgApi} from "../domain/utils";

   export default {
        name: "user-profile",
      data()
      {
        return {

        }
      },
      computed:{
        ...mapState([ 'user' ] ),
        avatarUser()
        {
          return imgApi(this.user.foto)
        }      }
    }
</script>

<style scoped>
.profile-alias{
  font-weight: bold;
  color: #0f1417;
}
  a{
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/UserProfile.vue